import { render, staticRenderFns } from "./VarientPopover.vue?vue&type=template&id=3a707320"
import script from "./VarientPopover.vue?vue&type=script&lang=js"
export * from "./VarientPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports